/**
 * Local theme preview helpers (127.0.0.1 / localhost only).
 * 1) Rewrites absolute storefront links (live domain) to the current local origin
 *    so navigation / Buy Now / product links stay on the preview.
 * 2) Checkout still opens on Shopify-hosted checkout (platform requirement) —
 *    we only confirm so it is not a surprise jump during testing.
 */
(function () {
  var host = window.location.hostname;
  if (host !== '127.0.0.1' && host !== 'localhost') return;

  var storeDomains = [];
  try {
    var raw = document.body && document.body.getAttribute('data-store-domains');
    if (raw) {
      storeDomains = raw.split(',').map(function (d) {
        return d.trim();
      });
    }
  } catch (e) {}

  if (window.Shopify && Shopify.shop) {
    storeDomains.push(Shopify.shop);
  }

  storeDomains = storeDomains
    .filter(Boolean)
    .map(function (d) {
      return String(d)
        .replace(/^https?:\/\//i, '')
        .replace(/\/$/, '')
        .toLowerCase();
    })
    .filter(function (d, i, arr) {
      return arr.indexOf(d) === i;
    });

  function isStoreHost(hostname) {
    hostname = (hostname || '').toLowerCase();
    return storeDomains.some(function (d) {
      return hostname === d || hostname.endsWith('.' + d);
    });
  }

  function toLocalHref(href) {
    if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
      return null;
    }
    try {
      var url = new URL(href, window.location.origin);
      if (!isStoreHost(url.hostname)) return null;
      // Keep checkout/account on Shopify hosts — cannot run on localhost.
      if (/^\/(checkouts?|account)(\/|$)/i.test(url.pathname)) return null;
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return null;
    }
  }

  function rewriteAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    var href = anchor.getAttribute('href');
    var local = toLocalHref(href);
    if (local) anchor.setAttribute('href', local);
  }

  function rewriteAll(root) {
    (root || document).querySelectorAll('a[href]').forEach(rewriteAnchor);
  }

  document.addEventListener(
    'click',
    function (event) {
      var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!anchor) return;
      rewriteAnchor(anchor);
      var href = anchor.getAttribute('href') || '';
      try {
        var url = new URL(href, window.location.origin);
        if (isStoreHost(url.hostname) && !/^\/(checkouts?|account)(\/|$)/i.test(url.pathname)) {
          event.preventDefault();
          window.location.assign(url.pathname + url.search + url.hash);
        }
      } catch (e) {}
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var submitter = event.submitter;
      var isCheckout =
        (submitter && (submitter.name === 'checkout' || submitter.id === 'checkout')) ||
        (form.querySelector && form.querySelector('button[name="checkout"], input[name="checkout"]'));

      // Product forms posting to /cart/add with payment_button click also leave local.
      var action = (form.getAttribute('action') || '').toLowerCase();
      var leavingForCheckout =
        isCheckout ||
        action.indexOf('/checkout') !== -1 ||
        (submitter && submitter.closest && submitter.closest('[data-shopify="payment-button"]'));

      if (!leavingForCheckout) return;

      var ok = window.confirm(
        'Shopify checkout cannot run on localhost.\n\n' +
          'It will open on your live store domain to complete payment testing.\n\n' +
          'Continue to checkout?'
      );
      if (!ok) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rewriteAll(document);
    });
  } else {
    rewriteAll(document);
  }

  // Catch AJAX-injected product cards / carts
  try {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href]')) rewriteAnchor(node);
          if (node.querySelectorAll) rewriteAll(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
